import { Menu } from '../shared/menu/menu.model';

export class MenuParameters {
    
    name: string;
    category: string;
    menu: Menu;

    constructor(name: string, category: string, menu: Menu) {
        this.name = name;
        this.category = category;
        this.menu = menu;
    }
}